import { render, staticRenderFns } from "./Stadium.vue?vue&type=template&id=b5f705e0"
import script from "./Stadium.vue?vue&type=script&lang=js"
export * from "./Stadium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports